module.exports = __webpack_public_path__ + "img/blt-resorthotel.b35de303.svg";